export default {
    reset_password_title: "Redefinir Senha",
    current_password: "Senha atual",
    new_password: "Nova senha",
    repeat_new_password: "Repita a nova senha",
    save: "Salvar",
    fill_all_fields: "Por favor, preencha todos os campos",
    passwords_dont_match: "Os campos de senha e repita a senha não são iguais",
    wrong_password: "A senha informada não procede",
    password_changed_success: "Senha alterada com sucesso.",
    page_title: "Kevi | Redefinir Senha",
    two_factor: {
        title: "Autenticação 2FA",
        setup_title: "Configurar Autenticação de 2 Fatores",
        scan_instruction:
            "Escaneie o QRCode com seu App Autenticador para que possa prosseguir para os próximos passos",
        scanned_button: "Já escaneei",
        enter_code_title: "Insira o código de verificação",
        verify_code_placeholder: "Código de verificação",
        validate_button: "Validar Código",
        backup_codes_title: "Seus códigos de backup",
        backup_important_message:
            "Estes códigos são importantes e não aparecerão novamente. Anote-os em um local seguro para o caso de perder seu dispositivo.",
        copy_instruction:
            'Clique em "Copiar Códigos" para copiar todos os códigos de uma vez e poder retornar.',
        copy_codes_button: "Copiar Códigos",
        back_button: "Voltar",
        copy_success: "Códigos copiados com sucesso!",
        invalid_code: "Código inválido!",
        error_qr: "Erro ao gerar QR Code",
        error_backup: "Erro ao gerar códigos de backup",
    },
    rewards: {
        title: "Kevi Fideliza",
        points: "pontos",
        points_label: "Pontos",
        use_now: "Utilizar agora",
        support_contact: "Para utilizar converse com o suporte",
        missing: "Faltam",
        missing_one: "Falta 1 ponto",
        page_title: "Meus pontos",
        confirm_redeem: "Tem certeza que quer resgatar seu prêmio?",
        redeem_success: "Prêmio resgatado com sucesso!",
    },
};
